import { Component } from '@angular/core';

@Component({
  selector: 'app-about',
  imports: [],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
})
export class AboutComponent {
  imageUrl: string;

  constructor() {
    const randomChance = Math.floor(Math.random() * 10);

    // 1% chance to show the alternate image
    if (randomChance === 0) {
      this.imageUrl = '../../../assets/images/IMG_5571resized.jpg'; // Alternate image
    } else {
      this.imageUrl = '../../../assets/images/IMG_5562resized.jpg'; // Default image
    }
  }
}
